import { AppBar, Grid, Toolbar, useTheme } from '@mui/material';
import { forwardRef } from 'react';

import { OpacityAnimation } from './opacity-animation.component';

export interface AppHeaderProps {
  action?: React.ReactNode;
  hideOnSmallScreens?: boolean;
}

export const AppHeader = forwardRef<HTMLElement, AppHeaderProps>(
  (props, ref) => {
    const theme = useTheme();
    return (
      <AppBar
        ref={ref}
        id="app-header"
        position="sticky"
        sx={{
          width: '100%',
          px: 2,
          pt: 'var(--safe-area-inset-top)',
          borderBottom: `1px solid ${theme.palette.divider}`,
          ...(props.hideOnSmallScreens && {
            [theme.breakpoints.down('sm')]: {
              display: 'none',
            },
          }),
        }}
      >
        <Toolbar
          sx={{
            justifyContent: 'center',
            width: '100%',
            py: 2,
          }}
        >
          <OpacityAnimation>
            <Grid container>
              <Grid size={12}>{props.action && <>{props.action}</>}</Grid>
            </Grid>
          </OpacityAnimation>
        </Toolbar>
      </AppBar>
    );
  },
);
